module.exports = __webpack_public_path__ + "img/success.39af0a08.gif";